module.exports = __webpack_public_path__ + "img/pen.72d75321.svg";